import React from 'react';
import { Grid } from '@mui/material';
import Information from './UnitRequirements/Information';
import { SkillSetWrapper } from './UnitRequirements/Experience/SkillSetWrapper';

export const UnitRequirementsSection = ({ unitInformationRef, unitExperienceRef }) => {
  return (
    <>
      <Grid container ref={unitInformationRef}>
        <Information />
      </Grid>
      <Grid container ref={unitExperienceRef}>
        <SkillSetWrapper />
      </Grid>
    </>
  );
};
